import { ApiError } from '@core/models';

export interface State {
  googleMapsApiLoaded: boolean;
  googleMapsApiLoading: boolean;
  googleMapsApiLoadedFailure: ApiError | null;
}

export const initialState: State = {
  googleMapsApiLoaded: false,
  googleMapsApiLoading: false,
  googleMapsApiLoadedFailure: null,
};
